import { pick } from 'lodash'
import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  topics: {},
  info: {}
}

const getInfoActions = generateActions('feedback/GET_INFO')
const postActions = generateActions('feedback/POST_MESSAGE')

export const get = createAction(
  API_CONST,
  () => ({
    actions: getInfoActions,
    url: 'feedback/send'
  })
)

export const send = createAction(
  API_CONST,
  (data = {}) => ({
    method: 'POST',
    params: { ...data, ...{platform: 'site'} },
    url: 'feedback/send',
    actions: postActions
  })
)

export default handleActions({
  [getInfoActions[0]]: state => ({ ...initial }),
  [getInfoActions[1]]: (state, { payload }) => ({
    ...state,
    topics: payload.topics,
    info: pick(payload, [ 'name', 'contact', 'phone', 'email' ])
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/feedback/index.js